import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PatientScoreConfigMstApi } from '../api/patientscoreconfigmst.api';
import { HttpParams } from '@angular/common/http';
import { PatientScoreConfigData, PatientScoreTransDto } from '../../../interfaces/masters/scoreconfigmst';

@Injectable({
    providedIn: 'root'
  })
export class PatientScoreConfigMstService extends PatientScoreConfigData {
  constructor(private api:PatientScoreConfigMstApi){
    super();
   }

  getByName<type>(url:string,queryparams:HttpParams): Observable<type>{
    return this.api.getByName(url,queryparams);
}
    get(url:string,queryparams:HttpParams): Observable<PatientScoreTransDto[]>{
        return this.api.get(url,queryparams)
    }

    add(url:string,data:PatientScoreTransDto): Observable<PatientScoreTransDto[]>{
      return this.api.add(url,data)
    }

    update(url: string, data:PatientScoreTransDto,queryparams:HttpParams): Observable<PatientScoreTransDto[]> {
      return this.api.update(url,data,queryparams)
        
    }
}